import * as types from 'constants/ActionTypes';
import initialState from 'config/initialState';


function chargersList(placesById, chargers) {
  const places = {};
  chargers.forEach((charger) => {
    if (charger.places) {
      charger.places.forEach((place) => {
        places[place.pk] = Object.assign({}, placesById[place.pk] || null, place, {
          charger: charger.pk,
        });
      });
    }
  });
  return places;
}

export default function placesReducer(state = initialState.places, action) {
  const byId = {};
  const reviewsById = {};
  let placeId;

  switch (action.type) {

    case types.CACHED_CHARGERS.SUCCESS:
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, chargersList(state, action.response.data)),
      });

    case types.CHARGERS.SUCCESS:
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, chargersList(state, action.response.results)),
      });

    case types.CHARGERS_NEAR_IP.SUCCESS:
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, chargersList(state, action.response.results.data)),
      });

    case types.NEW_PLACE_REVIEW: {
      placeId = action.place;
      const review = action.review;
      const modified = new Date(review.modified);
      const nextReview = new Date(review.modified);
      nextReview.setDate(modified.getDate() + 30);
      const oldNumReviews = state.byId[placeId].num_reviews || 0;
      const oldAverageRating = state.byId[placeId].average_rating || 0;
      const oldAverageWalkabilityRating = state.byId[placeId].average_walkability_rating || 0;
      byId[placeId] = Object.assign({}, state.byId[placeId], {
        reviews: [review.pk, ...state.byId[placeId].reviews],
        num_reviews: oldNumReviews + 1,
        average_rating: ((oldAverageRating * oldNumReviews) + review.rating) / (oldNumReviews + 1),
        average_walkability_rating: (
          ((oldAverageWalkabilityRating * oldNumReviews) + review.walkability) / (oldNumReviews + 1)
        ),
        user_review_status: {
          num_reviews: state.byId[placeId].user_review_status.num_reviews + 1,
          last_reviewed: modified,
          next_review: nextReview,
          can_review: false,
        },
      });
      reviewsById[review.pk] = Object.assign({}, review, {
        user: review.user ? review.user.pk || review.user : null,
        place: placeId,
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        reviewsById: Object.assign({}, state.reviewsById, reviewsById),
      });
    }

    case types.PLACE_REVIEWS.SUCCESS: {
      placeId = action.place;
      const reviewIds = action.response.results.map((review) => {
        reviewsById[review.pk] = Object.assign({}, state.reviewsById[review.pk] || null, review, {
          user: review.user ? review.user.pk || review.user : null,
          place: placeId,
        });
        return review.pk;
      });
      byId[placeId] = Object.assign({}, state.byId[placeId], {
        reviews: reviewIds,
        num_reviews: reviewIds.length,
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        reviewsById: Object.assign({}, state.reviewsById, reviewsById),
      });
    }

    case types.PLACES.SUCCESS: {
      action.response.results.forEach((place) => {
        byId[place.pk] = Object.assign({}, state.byId[place.pk] || null, place);
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
      });
    }

    case types.CHARGER_PLACES.SUCCESS: {
      const chargerId = parseInt(action.charger, 10);
      action.response.results.forEach((place) => {
        const chargersNear = state.byId[place.pk] ? state.byId[place.pk].chargers || [] : [];
        if (chargersNear.indexOf(chargerId) === -1) chargersNear.push(chargerId);
        byId[place.pk] = Object.assign({}, state.byId[place.pk] || null, place, {
          chargers: chargersNear,
        });
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
      });
    }

    case types.USER.SUCCESS: {
      if (action.response.place_reviews) {
        action.response.place_reviews.forEach((review) => {
          if (typeof review.place === 'object') {
            byId[review.place.pk] = Object.assign(
              {}, state.byId[review.place.pk] || null, review.place);
          }
          reviewsById[review.pk] = Object.assign({}, state.reviewsById[review.pk] || null, review, {
            user: parseInt(action.response.pk, 10),
            place: review.place.pk,
          });
        });
      }
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        reviewsById: Object.assign({}, state.reviewsById, reviewsById),
      });
    }

    case types.NEW_PLACE: {
      const place = action.data;
      byId[place.pk] = Object.assign({}, action.data, {
        num_reviews: 0,
        user_review_status: {
          num_reviews: 0,
          last_reviewed: null,
          next_review: null,
          can_review: true,
        },
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
      });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/scripts/reducers/PlaceReducers.js